import React from "react";

interface StatCardProps {
  label: string;
  value: string | number;
  subtext?: string;
  trend?: {
    direction: "up" | "down" | "neutral";
    value: string;
  };
  icon?: string;
  className?: string;
}

export function StatCard({
  label,
  value,
  subtext,
  trend,
  icon,
  className = "",
}: StatCardProps): React.JSX.Element {
  return (
    <div
      className={`stat-card ${className}`}
      role="group"
      aria-label={`${label}: ${value}`}
    >
      <div className="stat-card-top">
        <span className="stat-card-label">{label}</span>
        {icon && (
          <span className="stat-card-icon" aria-hidden="true">
            {icon}
          </span>
        )}
      </div>
      <div className="stat-card-value">{value}</div>
      {(subtext || trend) && (
        <div className="stat-card-bottom">
          {trend && (
            <span className={`stat-card-trend trend-${trend.direction}`}>
              {trend.direction === "up" && "↑ "}
              {trend.direction === "down" && "↓ "}
              {trend.value}
            </span>
          )}
          {subtext && <span className="stat-card-subtext">{subtext}</span>}
        </div>
      )}
    </div>
  );
}
